import React, { useState } from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Chip, FormControlLabel, Switch } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import './JsonRenderer.css'; // Import your CSS file for styling

const JsonRenderer = ({ data }) => {
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [displayAsChips, setDisplayAsChips] = useState(false);

  const handleTitleClick = (title) => {
    setSelectedTitle(selectedTitle === title ? null : title);
  };

  const handleDisplayToggle = () => {
    setDisplayAsChips(!displayAsChips);
  };

  return (
    <div className="json-renderer-container">
      <div className="display-toggle">
        Display as Chips
        <FormControlLabel
          control={<Switch checked={displayAsChips} onChange={handleDisplayToggle} />}
        />
      </div>
      <List className="json-titles">
        {Object.keys(data).map((title, index) => (
          <ListItem
            key={index}
            button
            onClick={() => handleTitleClick(title)}
            selected={title === selectedTitle}
            className="json-title"
          >
            <ListItemIcon>
              {title === selectedTitle ? <ExpandMoreIcon /> : <ChevronRightIcon />}
            </ListItemIcon>
            <ListItemText 
             primary={`${title} (${data[title].count})`} // Display title with count
            />
          </ListItem>
        ))}
      </List>
      {selectedTitle && (
        <div className="json-values">
          <strong>{selectedTitle}:</strong> {data[selectedTitle].count} questions
          <div className="highlight-box">
            <strong>{data[selectedTitle].summary || "Ai genereated summarized question"}</strong>
          </div>
          {displayAsChips ? (
            <div className="chips-container">
              {data[selectedTitle].questions.map((value, index) => (
                <Chip key={index} label={`${index + 1}. ${value}`} className="json-value-chip" />
              ))}
            </div>
          ) : (
            <ol>
              {data[selectedTitle].questions.map((value, index) => (
                <li key={index} className="json-value-item">
                  {value}
                </li>
              ))}
            </ol>
          )}
        </div>
      )}
    </div>
  );
};

export default JsonRenderer;
